import axios from 'axios';
import { OpenVidu } from './openvidu';

export default async (
  serverHost,
  ticketId,
  onAddSubscriber,
  onAddPublisher,
  onInitComplete,
  onStreamDestroyed,
  onSessionDisconnect,
  onChatMessage,
  noVideoCanvas,
) => {
  const OV = new OpenVidu();

  const sessionId = `ticket-${ticketId}`;

  const session = OV.initSession();
  OV.enableProdMode();

  // thire

  session.on('sessionDisconnected', (event) => {
    console.log('sessionDisconnected === ', event);
    event.preventDefault();
    onSessionDisconnect(event);
  });

  session.on('streamDestroyed', (event) => {
    console.log('streamDestroyed === ', event);
    event.preventDefault();
    onStreamDestroyed(event);
    // TODO
  });

  session.on('streamCreated', (event) => {
    console.log('streamCreated === ', event);
    const subscriber = session.subscribe(event.stream, undefined);
    onAddSubscriber(subscriber);
  });

  session.on('connectionDestroyed', (event) => {
    event.preventDefault();
  });

  session.on('signal:userChanged', (event) => {
    console.log('userChanged === ', event);
    // dispatch(messageConfirm(event.data));
  });

  session.on('signal:chat-message-confirm', () => {
    // console.log('messageConfirm === ', event);
    // dispatch(messageConfirm(event.data));
  });

  session.on('signal:chat-message', (event) => {
    // console.log('addChatMessage === ', event);
    const { data } = event;
    const message = JSON.parse(data);
    onChatMessage(message);
  });

  const getToken = async () => {
    try {
      const tokenReq = await axios.get(`https://${serverHost}/api/media/token?sessionId=${sessionId}`);
      const { data: { token } } = tokenReq;
      return token;
    } catch (e) {
      return getToken();
    }
  };

  try {
    const token = await getToken();

    if (token) {
      session.connect(token, { clientData: '' })
        .then(async () => {
          const userStream = await navigator.mediaDevices.getUserMedia({
            audio: {
              echoCancellation: true,
              noiseSuppression: false,
              autoGainControl: false,
            },
            video: false,
          });
          const audioTracks = userStream.getAudioTracks();
          const ourAudioTrack = audioTracks[0];
          const noVideoMediaTrack = noVideoCanvas.captureStream().getVideoTracks()[0];
          const publisher = OV.initPublisher(undefined, {
            audioSource: ourAudioTrack,
            videoSource: noVideoMediaTrack,
            publishAudio: true,
            publishVideo: true,
            resolution: '640x480',
            insertMode: 'APPEND',
            frameRate: 30,
            mirror: false,
          });
          // console.log('publisherpublisherpublisher === ', publisher);
          // publisher.subscribeToRemote();
          session.publish(publisher);
          onAddPublisher(publisher);
          onInitComplete(session, sessionId);
        }).catch((error) => {
          console.error('There was an error connecting to the session:', error.code, error.message);
        });
    }
  } catch (e) {
    console.error(e);
  }
  return OV;
};
